export const SIMULATION_API_URL = 'https://simulation.a.exodus.io';
